import MissionClientForm from "components/form/mission/MissionClientForm";
import MissionInfoForm from "components/form/mission/MissionInfoForm";
import propTypes from "prop-types";

const MissionGeneralInfo = ({
  clearErrors,
  control,
  errors,
  register,
  setErrors,
  setValue,
  unregister,
  watch,
  getValues,
}) => {
  return (
    <>
      <MissionInfoForm
        setValue={setValue}
        setValueAndClearError={(field, value) => {
          setValue(field, value);
          clearErrors(field);
        }}
        getValues={getValues}
        watch={watch}
        control={control}
        register={register}
        errors={errors}
        unregister={unregister}
        clearErrors={clearErrors}
        setErrors={setErrors}
      />
      <MissionClientForm
        setValue={(field, value) => {
          setValue(field, value);
          clearErrors(field);
        }}
        watch={watch}
        control={control}
        register={register}
        errors={errors}
        unregister={unregister}
        clearErrors={clearErrors}
        setErrors={setErrors}
      />
    </>
  );
};

export default MissionGeneralInfo;

MissionGeneralInfo.propTypes = {
  clearErrors: propTypes.func.isRequired,
  control: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  register: propTypes.func.isRequired,
  setErrors: propTypes.func.isRequired,
  setValue: propTypes.func.isRequired,
  unregister: propTypes.func.isRequired,
  watch: propTypes.func.isRequired,
  getValues: propTypes.func.isRequired,
};
